<template>
  <ybl-dialog
    :visible="show"
    :title="title"
    width="300px"
    :modal="modal"
    :showFooter="!!appId"
    @close="close"
    @confirm="submit"
  >
    <ybl-qrcode ref="dialog" @next="nextValidate" @scan="nextValidate"></ybl-qrcode>
  </ybl-dialog>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      modal: true,
      title: '安全验证',
      appId: ''
    }
  },
  mounted () {
    const container = document.querySelector('.el-dialog__wrapper:not(.dislog-box)') || document.body
    container.appendChild(this.$el)
  },
  methods: {
    nextValidate (action, appId) {
      // console.log('🚀 ~ GzhDialog.vue:20 ~ nextValidate ~ action:', action, appId)
      this.title = appId ? '安全验证' : '扫码绑定公众号'
      this.appId = appId || ''
      this.$emit('next', action, appId)
      action === 'continue' && this.close()
    },
    close () {
      this.show = false
    },
    submit () {
      // 提交表单
      this.$refs.dialog.submit()
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/GzhDialog.vue